module.exports = __webpack_public_path__ + "static/media/male.03244ab2.png";